import { useSnackbar } from "notistack"
import { useMemo, useRef } from "react"
import { RecPatch } from "~/dataProvider/tools"
import retrieveAxiosErr from "~/utils/retrieveAxiosErr"

export const useDefaultSavedHandlers = (msgLabel: string|(()=>string)) => {
  const { enqueueSnackbar } = useSnackbar()
  const msgLabelRef = useRef(msgLabel)
  msgLabelRef.current = msgLabel
  
  return useMemo(() => {
    const successHandlers = [
      function defaultOnSuccess({data}: {data:RecPatch}) {
        let labelStr = typeof msgLabelRef.current === 'function' ? msgLabelRef.current() : msgLabelRef.current
        enqueueSnackbar(`${labelStr} succeed`, { variant: 'success' })
      }
    ]
    const failureHandlers = [
      function defaultOnFailure(err:any) {
        const errMsg = retrieveAxiosErr(err)
        let labelStr = typeof msgLabelRef.current === 'function' ? msgLabelRef.current() : msgLabelRef.current
        enqueueSnackbar(`${labelStr} failed: ${errMsg}`, { variant: 'error' })
      }
    ]
    const onSuccess = (x: {data:RecPatch}) => {
      for(var handler of successHandlers) { handler(x) }
    }
    const onFailure = (err: any) => {
      for(var handler of failureHandlers) { handler(err) }
    }
    onSuccess.merge = (handler: (x:{data:RecPatch}) => void) => {
      if (successHandlers.indexOf(handler) === -1) {
        successHandlers.push(handler)
      }
      return onSuccess
    }
    onFailure.merge = (handler: (err:any) => void) => {
      if (failureHandlers.indexOf(handler) === -1) {
        failureHandlers.push(handler)
      }
      return onFailure
    }
    return {
      onSuccess,
      onFailure,
    }
  }, [enqueueSnackbar])
}